var React = require('react');

function IconPhone (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M22.656,27h-.026c-4.1-.134-8.9-4.108-12.212-7.42S3.131,11.465,3,7.384c-.047-1.432,3.467-3.978,3.5-4a1.691,1.691,0,0,1,2.34.166c.281.39,2.945,4.426,3.235,4.884a1.922,1.922,0,0,1-.119,1.892c-.207.394-.893,1.6-1.215,2.163a28.668,28.668,0,0,0,3.162,3.6,28.718,28.718,0,0,0,3.605,3.164c.563-.322,1.769-1.008,2.163-1.215a1.93,1.93,0,0,1,1.882-.124c.49.3,4.515,2.977,4.886,3.235A1.4,1.4,0,0,1,27,22.181a2.019,2.019,0,0,1-.381,1.315C26.592,23.53,24.075,27,22.656,27Z","transform":"translate(-3.003 -2.998)","fill":"#0ede70"}));
}

IconPhone.defaultProps = {"width":"24","height":"24.003","viewBox":"0 0 24 24.003"};

module.exports = IconPhone;

IconPhone.default = IconPhone;
